import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { FacadeService } from '../../service/facade/facade.service';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Worker } from '../../../workers/shared/model/worker.model';

@Injectable()
export class WorkerFromRequestResolver implements Resolve<Observable<Worker[]>> {
  constructor(private facadeService: FacadeService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Worker[]> {
    const requestId = route.queryParams['r'];

    // If requestId
    if (requestId) {
      return this.facadeService.getRequestById(+requestId).pipe(
        mergeMap((request) => {
          if (request.workerId) {
            return this.facadeService.getWorkerById(+request.workerId).pipe(
              map((worker) => [worker]),
              catchError(error => of([]))
            );
          } else {
            // If no workerId, return all active workers
            return this.facadeService.getAllActiveWorkers().pipe(
              map((workers) => workers),
              catchError(error => of([]))
            );
          }
        }),
        catchError(error => of([]))
      );
    } 
  }
}